import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectTreatmentPlan } from '../../../../treatment/state/plan/selector'


export default {
    taskName: taskName.CREATE_REFINEMENT_PLAN_EXTERNAL,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_PLAN_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext, selectTreatmentPlan,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context, treatmentPlan) => {
        const messageList = []

        if (eventName === 'plan_done') {
            const { numberOfAlignerLowerJaw, numberOfAlignerUpperJaw, treatmentDuration } = treatmentPlan

            if (!numberOfAlignerLowerJaw && numberOfAlignerLowerJaw !== 0) {
                messageList.push(createValidationMessage('Please add number of aligner lower jaw.', 'treatmentplan.numberOfAlignerLowerJaw'))
            }
            if (!numberOfAlignerUpperJaw && numberOfAlignerUpperJaw !== 0) {
                messageList.push(createValidationMessage('Please add number of aligner upper jaw.', 'treatmentplan.numberOfAlignerUpperJaw'))
            }
            if (!treatmentDuration) {
                messageList.push(createValidationMessage('Treatment duration has not been calculated', 'treatmentplan.treatmentDuration'))
            }
            return messageList
        }

        return messageList
    },
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/create-refinement-plan-external.js